class CustomProductVideo extends HTMLElement {
constructor() {
  super();
}
connectedCallback() {
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(entries[0].target);

    var filtercustom = new Swiper(".custom-video-slider", {
      spaceBetween:16,
      slidesPerView:"auto",
      navigation: {
        nextEl: ".video-swiper-next",
        prevEl: ".video-swiper-prev",
      },
    });

    let popupSwiper;
    let videoProgressRAF;
    // document.querySelectorAll('.custom-video-slider .swiper-slide').forEach((slide, index) => {
    //   slide.addEventListener('click', () => {
    //     const allSlides = document.querySelectorAll('.custom-video-slider .swiper-slide');
    //     const totalSlides = allSlides.length;
    
    //     document.getElementById('videoPopup').classList.remove('hidden');
    
    //     const popupWrapper = document.getElementById('popupSwiperWrapper');
    //     popupWrapper.innerHTML = '';
    
    //     for (let i = index; i < totalSlides; i++) {
    //       const clonedSlide = allSlides[i].cloneNode(true);
    //       popupWrapper.appendChild(clonedSlide);
    //     }

    //     const paginationContainer = document.getElementById('customVideoPagination');
    //     paginationContainer.innerHTML = '';
    //     for (let i = index; i < totalSlides; i++) {
    //       const bar = document.createElement('div');
    //       bar.className = 'progress-bar';
    //       bar.innerHTML = `<div class="fill"></div>`;
    //       paginationContainer.appendChild(bar);
    //     }
    
    //     if (popupSwiper) {
    //       popupSwiper.destroy(true, true);
    //       popupSwiper = null;
    //     }

    //     popupSwiper = new Swiper('.popup-swiper', {
    //       initialSlide: 0,
    //       spaceBetween: 10,
    //       slidesPerView: 1,
    //       loop: true,
    //       allowTouchMove: true,
    //       navigation: {
    //         nextEl: ".popup-video-swiper-next",
    //         prevEl: ".popup-video-swiper-prev",
    //       },
    //       on: {
    //         init: () => autoplayActiveSlideVideo(),
    //         slideChange: () => {
    //           setTimeout(() => {
    //             autoplayActiveSlideVideo();
    //           }, 100);
    //         }
    //       }
    //     });
    //   });
    // });
    
    document.querySelectorAll('.custom-video-slider .swiper-slide').forEach((slide, index) => {
      slide.addEventListener('click', () => {
        $('body').css({"overflow":"hidden"});
        const allSlides = document.querySelectorAll('.custom-video-slider .swiper-slide');
        const totalSlides = allSlides.length;
    
        document.getElementById('videoPopup').classList.remove('hidden');
    
        const popupWrapper = document.getElementById('popupSwiperWrapper');
        popupWrapper.innerHTML = '';
    
        allSlides.forEach((slide) => {
          const clonedSlide = slide.cloneNode(true);
          popupWrapper.appendChild(clonedSlide);
        });
    
        const paginationContainer = document.getElementById('customVideoPagination');
        paginationContainer.innerHTML = '';
    
        allSlides.forEach(() => {
          const bar = document.createElement('div');
          bar.className = 'progress-bar';
          bar.innerHTML = `<div class="fill"></div>`;
          paginationContainer.appendChild(bar);
        });
    
        if (popupSwiper) {
          popupSwiper.destroy(true, true);
          popupSwiper = null;
        }
    
        popupSwiper = new Swiper('.popup-swiper', {
          initialSlide: index,
          spaceBetween: 0,
          slidesPerView: 1,
          loop: true,
          allowTouchMove: true,
          navigation: {
            nextEl: ".popup-video-swiper-next",
            prevEl: ".popup-video-swiper-prev",
          },
          on: {
            init: () => autoplayActiveSlideVideo(),
            slideChange: () => {
              setTimeout(() => {
                autoplayActiveSlideVideo();
              }, 100);
            }
          }
        });
      });
    });

    function autoplayActiveSlideVideo() {
      document.querySelectorAll('.popup-swiper .media-video').forEach(video => {
        video.pause();
        video.currentTime = 0;
        video.onended = null;
      });
    
      const activeSlide = document.querySelector('.popup-swiper .swiper-slide-active');
      const playBtn = document.getElementById('popupVideoPlay');
      if (activeSlide) {
        const video = activeSlide.querySelector('.media-video');
        if (video) {
          video.muted = false;
          video.play().then(() => {
            syncPaginationWithVideo(video);
            if (playBtn) playBtn.innerHTML = '<svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 14C9.45 14 8.97933 13.8043 8.588 13.413C8.19667 13.0217 8.00067 12.5507 8 12V2C8 1.45 8.196 0.979335 8.588 0.588001C8.98 0.196668 9.45067 0.000668362 10 1.69492e-06C10.5493 -0.000664972 11.0203 0.195335 11.413 0.588001C11.8057 0.980668 12.0013 1.45134 12 2V12C12 12.55 11.8043 13.021 11.413 13.413C11.0217 13.805 10.5507 14.0007 10 14ZM2 14C1.45 14 0.979333 13.8043 0.588 13.413C0.196666 13.0217 0.000666667 12.5507 0 12V2C0 1.45 0.196 0.979335 0.588 0.588001C0.98 0.196668 1.45067 0.000668362 2 1.69492e-06C2.54933 -0.000664972 3.02033 0.195335 3.413 0.588001C3.80567 0.980668 4.00133 1.45134 4 2V12C4 12.55 3.80433 13.021 3.413 13.413C3.02167 13.805 2.55067 14.0007 2 14Z" fill="white"/></svg>'; // Reset play/pause icon
          }).catch(e => console.warn("Autoplay failed", e));
    
          video.onended = () => {
            const currentRealIndex = popupSwiper.realIndex;
            const totalBars = document.querySelectorAll('.custom-video-pagination .progress-bar').length;

            if (currentRealIndex === 0) {
              document.querySelectorAll('.custom-video-pagination .progress-bar .fill').forEach(bar => {
                bar.style.width = '0%';
              });
            }
    
            popupSwiper.slideNext();
          };
        }
      }
    }

    function syncPaginationWithVideo(video) {
      cancelAnimationFrame(videoProgressRAF);
      const bars = document.querySelectorAll('.custom-video-pagination .progress-bar .fill');
      if (!popupSwiper || !video || bars.length === 0) return;
    
      const currentIndex = popupSwiper.realIndex;
    
      bars.forEach((bar, i) => {
        if (i < currentIndex) bar.style.width = '100%';
        else if (i > currentIndex) bar.style.width = '0%';
      });
    
      function updateProgress() {
        if (video.duration && !video.paused) {
          const percent = (video.currentTime / video.duration) * 100;
          if (bars[currentIndex]) {
            bars[currentIndex].style.width = `${percent}%`;
          }
        }
    
        if (!video.ended) {
          videoProgressRAF = requestAnimationFrame(updateProgress);
        }
      }
    
      updateProgress();
    }
    
    document.getElementById('popupVideoPlay').addEventListener('click', () => {
      const activeSlide = document.querySelector('.popup-swiper .swiper-slide-active');
      if (!activeSlide) return;
    
      const video = activeSlide.querySelector('.media-video');
      if (!video) return;
    
      const playBtn = document.getElementById('popupVideoPlay');
    
      if (video.paused) {
        video.play();
        if (playBtn) playBtn.innerHTML = '<svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 14C9.45 14 8.97933 13.8043 8.588 13.413C8.19667 13.0217 8.00067 12.5507 8 12V2C8 1.45 8.196 0.979335 8.588 0.588001C8.98 0.196668 9.45067 0.000668362 10 1.69492e-06C10.5493 -0.000664972 11.0203 0.195335 11.413 0.588001C11.8057 0.980668 12.0013 1.45134 12 2V12C12 12.55 11.8043 13.021 11.413 13.413C11.0217 13.805 10.5507 14.0007 10 14ZM2 14C1.45 14 0.979333 13.8043 0.588 13.413C0.196666 13.0217 0.000666667 12.5507 0 12V2C0 1.45 0.196 0.979335 0.588 0.588001C0.98 0.196668 1.45067 0.000668362 2 1.69492e-06C2.54933 -0.000664972 3.02033 0.195335 3.413 0.588001C3.80567 0.980668 4.00133 1.45134 4 2V12C4 12.55 3.80433 13.021 3.413 13.413C3.02167 13.805 2.55067 14.0007 2 14Z" fill="white"/></svg>';
      } else {
        video.pause();
        if (playBtn) playBtn.innerHTML = '<svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L11 7L1 13V1Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      }
    });
      

      document.getElementById('closePopup').addEventListener('click', () => {
        $('body').css({"overflow":"unset"});
        document.getElementById('videoPopup').classList.add('hidden');
          if (popupSwiper) {
            popupSwiper.destroy(true, true);
            popupSwiper = null;
          }
          document.getElementById('popupSwiperWrapper').innerHTML = '';
      });

      document.getElementById('video-popup-overlay').addEventListener('click', () => {
        $('body').css({"overflow":"unset"});
        document.getElementById('videoPopup').classList.add('hidden');
          if (popupSwiper) {
            popupSwiper.destroy(true, true);
            popupSwiper = null;
          }
          document.getElementById('popupSwiperWrapper').innerHTML = '';
       });
    
    };
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });
    observer.observe(this);
  }
 }
customElements.define("custom-main-product-info", CustomProductVideo);